import { render, staticRenderFns } from "./avalonCourseContentSettings.vue?vue&type=template&id=486f564e&scoped=true&"
import script from "./avalonCourseContentSettings.vue?vue&type=script&lang=js&"
export * from "./avalonCourseContentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f564e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
